import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';

import { Observable } from 'rxjs';
import { map, catchError, concatMap, switchMap } from 'rxjs/operators';

import { EmailDigestActionTypes } from '../actions/email-digest.actions';
import { AppState } from '..';
import { UserMessages } from '../../constants/userMessages.constants';
import { EmailDigestService } from '../../services/email-digest.service';
import { EmailDigest } from '../../tamalelibs/models/emaildigest.model';

@Injectable()
export class EmailDigestEffect {
    constructor(
        private _actions$: Actions,
        private _emailDigestService: EmailDigestService,
        private _store: Store<AppState>
    ) { }

    loadEmailDigestEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(EmailDigestActionTypes.LOAD),
        map((action: any) => action.payload),
        concatMap(payload => {
            return this._emailDigestService.getEmailDigestList().pipe(
                map(response => {
                    return ({
                        type: EmailDigestActionTypes.LOAD_SUCCESS,
                        payload: {
                            count: response.count,
                            items: this._emailDigestService.parseEmailDigestFromResponse(response['emaildigest-list']),
                        }
                    });
                })
            );
        }),
        catchError((err, caught) => {
            return this._errorHandler(err, caught, EmailDigestActionTypes.LOAD_FAILED);
        })
    ));

    getOneConfigEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(EmailDigestActionTypes.GET_EMAIL_DIGEST_CONFIG),
        map((action: any) => action.payload),
        switchMap(payload => {
            return this._emailDigestService.getEmailDigest(payload.id).pipe(
                map(response => {
                    return ({
                        type: EmailDigestActionTypes.GET_EMAIL_DIGEST_CONFIG_SUCCESS,
                        payload: EmailDigest.parse(response),
                    });
                })
            );
        }),
        catchError((err, caught) => {
            return this._errorHandler(err, caught, EmailDigestActionTypes.GET_EMAIL_DIGEST_CONFIG_FAILED);
        })
    ));

    switchActiveEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(EmailDigestActionTypes.SWITCH_ACTIVE),
        map((action: any) => action.payload),
        concatMap(payload => {
            return this._emailDigestService.updateEmailDigestActive(payload).pipe(
                map(response => {
                    return ({
                        type: EmailDigestActionTypes.SWITCH_ACTIVE_SUCCESS,
                        payload: EmailDigest.parse(response),
                    });
                })
            );
        }),
        catchError((err, caught) => {
            return this._errorHandler(err, caught, EmailDigestActionTypes.SWITCH_ACTIVE_FAILED);
        })
    ));

    switchSubscriptionEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(EmailDigestActionTypes.SWITCH_SUBSCRIPTION),
        map((action: any) => action.payload),
        concatMap(payload => {
            return this._emailDigestService.updateEmailDigestSubscription(payload).pipe(
                map(response => {
                    return ({
                        type: EmailDigestActionTypes.SWITCH_SUBSCRIPTION_SUCCESS,
                        payload: EmailDigest.parse(response),
                    });
                })
            );
        }),
        catchError((err, caught) => {
            return this._errorHandler(err, caught, EmailDigestActionTypes.SWITCH_SUBSCRIPTION_FAILED);
        })
    ));

    private _errorHandler(err, caught, type): Observable<Action> {
        let errorMsg = '';
        if (err.message && err.message.indexOf('401') > -1 && err.message.indexOf('Unauthorized') > -1) {
            errorMsg = UserMessages.onLoginInvalid;
        } else {
            errorMsg = UserMessages.onAPIDown;
        }
        this._store.dispatch({ type: type, payload: errorMsg });
        return caught;
    }

}
